import { dateType } from "./setting";
import { cr } from "fire-wind-water";
import { toValue } from "./to";

class List {
  constructor() {}

  setItem(ts: any, value: any, model: any): { [label: string]: any } {
    const m = {
      year: model.year,
      month: model.month,
      date: model.date,
      hours: model.hours,
      minute: model.minute,
      second: model.second,
    };
    cr.each(ts, (d) => {
      m[d] = value[d];
    });
    return m;
  }

  isClassName(ts, value, model): boolean {
    let isClass = true;
    const len = dateType.indexOf(ts);
    for (let i = 0; i <= len; i++) {
      const d = dateType[i];
      if (value[d] !== model[d]) {
        isClass = false;
        break;
      }
    }
    return isClass;
  }

  getYearItem(i, value): any {
    const m = this.setItem(["year"], { year: i }, value);
    m.className = this.isClassName("year", m, value)
      ? "picker-selection active"
      : "picker-selection";
    return m;
  }

  year(value, model) {
    const val = value.year;
    const mv = toValue(model);
    const decade = val - (val % 10);
    const list = [this.getYearItem(decade - 1, mv)];
    const len = decade + 9;
    for (let i = decade; i <= len; i++) {
      list.push(this.getYearItem(i, mv));
    }
    list.push(this.getYearItem(decade + 10, mv));
    return list;
  }

  getMonthItem(i, value) {
    const m = this.setItem(
      ["year", "month"],
      { year: value.year, month: i },
      value
    );
    m.className = this.isClassName("month", m, value)
      ? "picker-selection active"
      : "picker-selection";
    return m;
  }

  month(value) {
    const list = [];
    for (let i = 1; i <= 12; i++) {
      const item = this.getMonthItem(i, value);
      item.html = `${i}月`;
      list.push(item);
    }
    return list;
  }

  getDateItem(i, value, model) {
    const m = this.setItem(
      ["year", "month", "date"],
      { year: value.year, month: value.month, date: i },
      value
    );
    m.className = this.isClassName("date", m, model)
      ? "picker-selection active"
      : "picker-selection";
    return m;
  }

  getPrevMonth(value, model, list) {
    let y = value.year;
    const m = value.month - 1;
    if (m <= 0) {
      y -= 1;
    }
    // 需要补齐数
    let week = new Date(value.year, value.month - 1, 1).getDay();
    // 如果是周日，就补齐6天
    switch (week) {
      case 0: // 如果是周日，补6天
        week = 6;
        break;
      case 1: // 如果是周一，补一周
        week = 7;
        break;
      default:
        week -= 1;
    }
    const md = new Date(y, m, 0).getDate() - week + 1;
    for (let i = 0; i < week; i++) {
      const item = this.getDateItem(
        md + i,
        {
          year: y,
          month: m === 0 ? 12 : m,
          date: value.date,
          hours: value.hours,
          minute: value.minute,
          second: value.second,
        },
        model
      );
      item.className = "picker-selection decade";
      list.push(item);
    }
  }

  getNextMonth(value, model, list) {
    let y = value.year;
    let m = value.month + 1;
    if (m > 12) {
      m = 1;
      y += 1;
    }
    const n = 7 * 6 - list.length;
    for (let i = 1; i <= n; i++) {
      const item = this.getDateItem(
        i,
        {
          year: y,
          month: m,
          date: value.date,
          hours: value.hours,
          minute: value.minute,
          second: value.second,
        },
        model
      );
      item.className = "picker-selection decade";
      list.push(item);
    }
  }

  getMonth(value, model, list) {
    const n = new Date(value.year, value.month, 0).getDate();
    for (let i = 1; i <= n; i++) {
      const item = this.getDateItem(i, value, model);
      list.push(item);
    }
  }

  date(value, model) {
    const list = [];
    const mvalue = toValue(model);
    this.getPrevMonth(value, mvalue, list);
    this.getMonth(value, mvalue, list);
    this.getNextMonth(value, mvalue, list);
    return list;
  }
}

export function relustList(ts, value, model) {
  const nl = new List();
  if (dateType.indexOf(ts) === -1) {
    console.error("Fuck, what kind of ghost");
    return;
  }
  return nl[ts](value, model);
}
